
import { defineComponent } from "vue";
import * as Lang from "@/i18n/lang";
import SeTable from "@/components/global/SeTable.vue";
import SeCalendarRanged from "@/components/global/SeCalendarRanged.vue";
import SeExpendable from "@/components/global/SeExpendable.vue";
import * as SecureatServerApi from "@/utils/SecureatServerApi";
import BillingSummary from "@/model/Billing/BillingSummary";
import SeDropdown from "@/components/global/dropdown/SeDropdown.vue";
import SeDropdownItem from "@/components/global/dropdown/SeDropdownItem.vue";
import Distributor from "@/model/Distributor";
import { getDistributorManager } from "@/firebase/DistributorManager";

export default defineComponent({
  name: "BillingSummary",
  components: {
    SeTable,
    SeCalendarRanged,
    SeExpendable,
    SeDropdown,
    SeDropdownItem,
  },
  data() {
    return {
      distributors: [] as Distributor[],
      Lang,
      summary: null as BillingSummary | null,
    };
  },
  methods: {
    async onDistributorChange(distributor: Distributor) {
      this.summary = await SecureatServerApi.getBillingSummary(
        new Date(),
        distributor.ref.id
      );

      console.log(this.summary);
    },
  },
  async mounted() {
    await getDistributorManager().initialize();
    this.distributors = await getDistributorManager().getDistributors();
  },
});
